import { Component, Injector, OnInit } from '@angular/core';
import { Input } from '@angular/core';
import { ExtendedEventBaseItem } from 'world-archery-lib';
import { DrupalLangClass } from '../../../../common-page-components/classes/drupal-lang-class';

@Component({
  selector: '[app-calendar-table]',
  templateUrl: './calendar-table.component.html',
  styleUrls: ['./calendar-table.component.scss']
})

export class CalendarTableComponent extends DrupalLangClass implements OnInit {

  @Input()
  Event: any = {} as any;
  showDetails = false;

  constructor(injector:Injector) {
    super(injector);
  }

  ngOnInit() {
  }

  onClick() {
    this.showDetails = !this.showDetails;
  }

}
